import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import tccStyles from "../common/styles";

const type = {
    running: "PROVISIONING_RUNNING",
    succeeded: "PROVISIONING_SUCCEEDED"
};

const styles = _ => {
    return {
        running: {
            background: tccStyles.progressBar.color.running
        },
        succeeded: { background: tccStyles.progressBar.color.succeeded }
    };
};

const MyLinearProgress = ({ progress_status, progress_type, classes }) => (
    <LinearProgress
        value={progress_status}
        variant="determinate"
        classes={{
            bar1Determinate:
                progress_type === type.succeeded
                    ? classes.succeeded
                    : classes.running
        }}
    />
);

const StyledLinearProgress = withStyles(styles)(MyLinearProgress);

export default class ProgressBar extends React.Component {
    static propTypes = {
        record: PropTypes.object
    };
    render() {
        const { record } = this.props;
        return record.type === type.running ||
            record.type === type.succeeded ? (
            <div style={{ textAlign: "center" }}>
                <span>{`${record.progress_status}%`}</span>
                <StyledLinearProgress
                    progress_status={record.progress_status}
                    progress_type={record.type}
                />
            </div>
        ) : null;
    }
}



// WEBPACK FOOTER //
// ./src/components/ProgressBar.js